import React from "react";
export default function MainContent() {
  const introParagraphs = ["A sua privacidade é de extrema importância para nós. Esta política descreve como coletamos, usamos e protegemos suas informações pessoais ao utilizar nossos serviços.", "Comprometemo-nos a garantir que seus dados permaneçam seguros e sejam tratados com a máxima transparência e conformidade legal."];
  return <section data-section-id="189015" id="visão-geral-da-política-de-privacidade" className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <h1 className="text-primary mb-6 text-6xl md:text-[4rem] font-bold font-default tracking-tight md:mb-8">
          Política de Privacidade
        </h1>
        
        <div className="text-foreground space-y-4 text-xl font-default">
          {introParagraphs.map((text, i) => <p key={i} data-index={i} className="leading-relaxed">
              {text}
            </p>)}
        </div>
      </div>
    </section>;
}